<template src="./Index.html">
</template>

<script>

    export default {
        created() {
            this.$store.dispatch("lookups/getLookups")
            this.$store.dispatch("lookups/getNationalities")
            this.$store.dispatch("lookups/getMunicipalities")

        },
        model: {
            prop: "employee",
        },

        props: ["employee"],
        computed: {
            genders() {
                return this.$store.getters["lookups/getLookupByType"](this.$lookupTypes.Genders);
            },
            nationalities() {
                return this.$store.state.lookups.nationalities;
            },
            municipalities() {
                return this.$store.state.lookups.municipalities;
            },  
            localities() {
                return this.$store.state.lookups.localities;
            },
            socialStatus() {
                return this.$store.getters["lookups/getLookupByType"](this.$lookupTypes.SocialStatus);
            },
            healthStatus() {
                return this.$store.getters["lookups/getLookupByType"](this.$lookupTypes.HealthStatus);
            },
            bloodTypes() {
                return this.$store.getters["lookups/getLookupByType"](this.$lookupTypes.BloodTypes);
            },
            identificationTypes() {
                return this.$store.getters["lookups/getLookupByType"](this.$lookupTypes.IdentificationTypes);
            },
      
        },
        data() {
            return {

            }
        },
        methods: {
            changeMunicipality(){
                this.$store.dispatch("lookups/getLocalities",this.employee.personalInformation.municipalityId)

            },
            uploadId() {
          
                const reader = new FileReader();
                if (event.target.files.length) {
                    reader.readAsDataURL(event.target.files[0])
                    reader.onload = (event) => {
                        this.employee.personalInformation.idCardPhoto = event.target.result;
                  

                    };
                }
            },
            uploadPass() {
          
                const reader = new FileReader();
                if (event.target.files.length) {
                    reader.readAsDataURL(event.target.files[0])
                    reader.onload = (event) => {
                        this.employee.personalInformation.passportPhoto = event.target.result;
                 

                    };
                }
            },

            prevStep() {

                this.$emit("prevStep");
            },

            nextStep() {
               this.$emit("nextStep");
            },
            allowedDates(val) {
                const today = new Date();
                today.setFullYear(today.getFullYear() - 15);
                const date = new Date(val);
                return date < today;
            },

            notFutureDates(val) {
                const today = new Date();
                const date = new Date(val);
                return date < today;
            },
           
        },
    };
</script>
